import React from "react";
import Reveal from "./Reveal";

const Philosophy = () => {
  return (
    <section
      data-testid="philosophy-section"
      className="relative bg-[var(--lt-charcoal)] text-[var(--lt-peace)] lt-grain"
    >
      <div className="container mx-auto px-6 lg:px-10 py-28 lg:py-40">
        <div className="grid grid-cols-12 gap-6 lg:gap-12">
          <div className="col-span-12 lg:col-span-3">
            <Reveal>
              <p className="eyebrow" style={{ color: "#D3B89D" }}>
                / Philosophy
              </p>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-9">
            <Reveal delay={120}>
              <h2
                data-testid="philosophy-headline"
                className="font-display tracking-editorial leading-[1.05] text-[var(--lt-peace)]"
                style={{ fontSize: "clamp(2rem, 4.6vw, 4.2rem)", fontWeight: 500 }}
              >
                The biggest opportunities in business today are
                <em className="italic text-[var(--lt-clay)]"> built on attention</em>.
                Founders, executives and brands with strong personal presence attract
                opportunity, partnership and capital naturally.
              </h2>
            </Reveal>

            <Reveal delay={260}>
              <p className="mt-10 max-w-2xl text-[var(--lt-clay)]/90 text-base lg:text-lg leading-relaxed">
                We focus on the small, powerful details that compound into influence.
                Strategy, content, distribution and storytelling. Most agencies stop at
                content. We start at branding. Because Big Things are built on Little Things.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
